import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters, equipments }) => {
    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">
                    <div>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>
                    <div>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>
                    <div>
                        <SelectComponent
                            label="Equipamento"
                            isMulti={true}
                            options={equipments}
                            value={filters.equipments}
                            onChange={selected => setFilters(prev => ({ ...prev, equipments: selected}))}
                            instanceId="equipment"
                            classNameWrapper={"w-full"}
                        />
                    </div>
                    <div>
                        <InputCheckbox
                            id="searchDetails"
                            label="Exibir detalhes"
                            className="ml-1"
                            value={filters.searchDetails}
                            onChange={() => setFilters(prev => ({...prev, searchDetails: !prev.searchDetails}))}
                        />
                    </div>
                </form>
            </div>
        </>
    );
};

export default Filters;